import { Box, Stack, styled } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import type React from "react";
import AnimatedEllipsis from "../animated-elipsis/AnimatedElipsis.tsx";
import SzLoading from "./SzLoading.tsx";

/**
 * Styled Backdrop from MUI
 * Modified color
 * Modified content alignment
 * @component
 * @category ui
 * @subcategory feedback
 */
const SzStyledBackdrop = styled(Backdrop)(({ theme }) => ({
	display: "flex",
	height: "100%",
	width: "100%",
	alignItems: "center",
	justifyContent: "center",
	position: "relative",
	backgroundColor: theme?.vars?.palette.background.paper,
}));

/**
 * Styled Box from MUI
 * centering loader
 * @component
 * @category ui
 * @subcategory feedback
 */
const SzStyledBox = styled(Box)(() => ({
	display: "flex",
	position: "absolute",
	left: "50%",
	top: "50%",
	transform: "translate(-50%, -50%)",
}));

/**
 * Styled backdrop with loader
 * @component
 * @category ui
 * @subcategory feedback
 */
const SzBackdrop: React.FC<{ sizeVariant?: number; message?: string }> = ({ sizeVariant, message }) => (
	<SzStyledBackdrop open={true}>
		<SzStyledBox>
			<Stack spacing={8}>
				<SzLoading
					logoVariant="text"
					sizeVariant={sizeVariant || 15}
					colorVariant="mix"
					mildCircle={true}
					mildLogo={true}
				/>
				{message && <AnimatedEllipsis variant="h3" component="span" displayedText={message} />}
			</Stack>
		</SzStyledBox>
	</SzStyledBackdrop>
);

export default SzBackdrop;
